import React from 'react';
import styles from "./Request.module.scss";
import global from '../../../styles/index.module.scss';
import { Accordion } from '../../../components/common/Accordion/Accordion';
import Img02 from '../../../assets/img/request/img02.jpg';
import Img03 from '../../../assets/img/request/img03.jpg';
import Img04 from '../../../assets/img/request/img04.jpg';
import Img05 from '../../../assets/img/request/img05.jpg';
import Img06 from '../../../assets/img/request/img06.jpg';
import Img08_sp from '../../../assets/img/request/img08_sp.jpg';
import Img_repair from '../../../assets/img/request/img_repair02.png';
import Img10 from '../../../assets/img/request/img10.jpg';
import Img11 from '../../../assets/img/request/img11.jpg';
import Img12 from '../../../assets/img/request/img12.jpg';
import Img13 from '../../../assets/img/request/img13.jpg';
import { Splide, SplideTrack, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';


declare global {
  interface Window {
    isLoggedIn: boolean;
    customerId: number;
  }
}

export const Request: React.FC = () => {
  return (
    <div className={styles.container}>
      <div>
        <div className={styles.mainFlex}>
          <div className={styles.mainItem01}>
            <h1 className={styles.headingLv1}>配送修理<br />ご利用の流れ</h1>
            <p className={styles.text}>ここでは、ミスターミニットのリペアセンターをご自宅からご利用いただく際の流れをご紹介いたします。</p>
          </div>
          <div className={styles.mainItem02}>
            <div className="request__splideWrapper">
              <Splide 
                hasTrack={ false } 
                aria-label="お気に入りの写真"
                options={{
                  type: 'loop',
                  arrows: false,
                }}
                >
                <SplideTrack>
                  <SplideSlide>
                  <img src={Img10} alt="Image 1"/>
                  </SplideSlide>
                  <SplideSlide>
                    <img src={Img11} alt="Image 2"/>
                  </SplideSlide>
                  <SplideSlide>
                    <img src={Img12} alt="Image 2"/>
                  </SplideSlide>
                  <SplideSlide>
                    <img src={Img13} alt="Image 2"/>
                  </SplideSlide>
                </SplideTrack>
                <ul className={styles.splide__pagination}></ul>
              </Splide>
            </div>
          </div>
        </div>
        <div className={styles.table}>
          <div className={styles.tableInner}>
            <p className={styles.tableTitle}>目次</p>
            <a href="#item1" className={styles.tableText}>はじめに:配送修理ご利用の流れ</a>
            <ol className={styles.tableList}>
              <li className={styles.tableListItem}>
                <a href="#item2">梱包する</a>
                <ol>
                  <li><a href="#item2-2">アイテム別注意事項</a></li>
                  <li><a href="#item2-3">「仮注文ID番号」を書いた紙を同封してください</a></li>
                </ol>
              </li>
              <li className={styles.tableListItem}>
                <a href="#item3">修理品をリペアセンターに発送する（発払い）</a>
                <ol>
                  <li><a href="#item3-1">発送方法</a></li>
                  <li><a href="#item3-2">伝票の書き方</a></li>
                </ol>
              </li>
              <li className={styles.tableListItem}>
                <a href="#item4">修理完了品を受け取る</a>
              </li>
            </ol>
            <a href="#item5" className={styles.faqText}>よくある質問</a>
          </div>
        </div>

        <div id="item1" className={styles.item1}>
          <h2 className={styles.headingLv2}>はじめに<br />配送修理ご利用の流れ</h2>
          <figure className={styles.img01}>
            <img src={Img02} alt="Img02" width={194} height={163}/>
          </figure>
          <div className={styles.startWrapper}>
            <section className={styles.startSection}>
              <div className={styles.startTextWrapper}>
                <h3 className={styles.startHeadingLv3}>
                  <p className={styles.labelText}>STEP
                    <span>1</span>
                  </p>
                  オンラインで診断・見積もりを依頼する
                </h3>
                <p className={styles.text}>画像と修理相談の内容を送り、見積もりをご依頼ください。（所要時間 約5分）</p>
                <a className={styles.onlineLink} href="">オンライン診断・見積もりサービスはこちら</a>
              </div>
              <figure className={styles.startImgWrapper}>
                <img src={Img03} alt="Img03" width={194} height={163}/>
                <p className={styles.startImgText}>修理したいアイテムの写真を撮って診断依頼</p>
                <p className={`${styles.labelText} ${styles.pc}`}>STEP
                  <span>1</span>
                </p>
              </figure>
            </section>
            <section className={styles.startSection}>
              <div className={styles.startTextWrapper}>
                <h3 className={styles.startHeadingLv3}>
                  <p className={styles.labelText}>STEP
                    <span>2</span>
                  </p>
                  配送修理を申し込む
                </h3>
                <p className={styles.text}>ご依頼内容を修理スタッフが確認し、修理プランを作成しメールで回答いたします。<br />配送修理をご希望の場合は、記載のメニューからプランを選択し、オンラインでお申し込みを行ってください。</p>
                <p className={styles.text}>・この時点では仮注文で費用・決済は発生しません。リペアセンターにお客様の修理品が届き検品した後にお支払い（決済）の依頼をいたします。</p>
                <p className={styles.text}>・リペアセンターに修理品が到着した後の、お客様都合によるキャンセルはできません（返送料はお客様負担）。</p>
              </div>
              <figure className={styles.startImgWrapper}>
                <img src={Img04} alt="Img04" width={194} height={163}/>
                <p className={`${styles.labelText} ${styles.pc}`}>STEP
                  <span>2</span>
                </p>
              </figure>
            </section>
            <section className={styles.startSection}>
              <div className={styles.startTextWrapper}>
                <h3 className={styles.startHeadingLv3}>
                  <p className={styles.labelText}>STEP
                    <span>3</span>
                  </p>
                  リペアセンターに修理品を梱包・発送する
                </h3>
                <p className={styles.text}> ユーザー登録（配送先住所の登録）を行った後、お客様ご自身で修理品を梱包し、リペアセンターに発送してください。<span className={styles.isBold}>（送料はお客様ご負担・発払いです）</span><br />リペアセンターに到着し、検品を行った後に修理金額が確定、お客様にお支払い（決済）依頼のメールが届きます。<br />当社でお支払いを確認後、修理をスタートいたします。</p>
                <p className={styles.text}>・お支払いはクレジットカード・PayPayがご利用いただけます。</p>
                <p className={styles.text}>※メールから5日以内にお支払いください。それ以降はキャンセルとなり、返送料はお客様のご負担となります</p>
                <br />
                <div className='u-dsp-pc'>
                  <div className={styles.startLinkWrapper}>
                    <a href="">梱包方法はこちら</a>
                    <a href="">配送方法はこちら</a>
                  </div>
                </div>
              </div>
              <figure className={styles.startImgWrapper}>
                <img src={Img05} alt="Img05" width={194} height={163}/>
                <p className={`${styles.labelText} ${styles.pc}`}>STEP
                  <span>3</span>
                </p>
              </figure>
              <div className='u-dsp-sp'>
                <div className={styles.startLinkWrapper}>
                  <a href="">梱包方法はこちら</a>
                  <a href="">配送方法はこちら</a>
                </div>
              </div>
            </section>
            <section className={styles.startSection}>
              <div className={styles.startTextWrapper}>
                <h3 className={styles.startHeadingLv3}>
                  <p className={styles.labelText}>STEP
                    <span>4</span>
                  </p>
                  修理完了品を受け取る
                </h3>
                <p className={styles.text}>リペアセンターにて修理が完了次第、修理品を返送いたします。<br />・スーツケースは返送料として一律1,650円をご負担いただきます。その他メニューは修理料金 3,300円以上で送料無料になります。 ※沖縄県への返送は、全メニューで修理料金にかかわらず送料をご負担いただきます。</p>
              </div>
              <figure className={styles.startImgWrapper}>
                <img src={Img06} alt="Img06" width={194} height={163}/>
                <p className={`${styles.labelText} ${styles.pc}`}>STEP
                  <span>4</span>
                </p>
              </figure>
            </section>
          </div>
        </div>
        <div id="item2" className={styles.item2}>
          <h2 className={styles.headingLv2}>梱包する</h2>
          <div className={styles.item2ContentWrapper}>
            <section  id="item2-2" className={styles.item2Section}>
              <h3 className={styles.item2HeadingLv3}>アイテム別注意事項</h3>
              <div className={styles.textWrapper}>
                <p className={styles.text}>梱包方法はアイテムによって異なります。<br />以下、該当するアイテムを選択して、梱包方法をご確認ください。</p>
              </div>
              <div className={styles.accordionWrapper}>
                <Accordion
                  title="靴（スニーカー）"
                  text={`・靴は濡れないように保護してください。（濡れると修理ができません）\n・段ボールなどの箱に入れ靴がつぶれないようにしてください。\n・靴の左右が当たって色移り、傷がつかないように梱包してください。\n・シューキーパーやご自身で購入された中敷きなどは入れないでください。\n・<span style="font-weight: bold; text-decoration: underline;">靴箱（購入時に付属していた箱）は送付しないでください。</span>\n\n※送付時・輸送中の破損については当社では責任を負いかねます。ご自身で適切に梱包してお送りください。。`}
                />
                <Accordion
                  title="バッグ/リュック"
                  text={`・濡れないように保護してください。（濡れると修理ができません）\n・<span style="font-weight: bold; text-decoration: underline;">バッグの中身は必ず取り出し、何も入っていない状態（中身を空（から））にしてください。</span>\n・<span style="font-weight: bold; text-decoration: underline;">ポケットの中身も必ずご確認ください。（小銭、パスケースなどのお忘れが多いです）</span>\n・バッグの保護袋は入れないでください。\n\n※送付時・輸送中の破損については当社では責任を負いかねます。ご自身で適切に梱包してお送りください。。`}
                />

                <Accordion
                  title="財布/ベルト/革小物"
                  text={`・中身を必ず取り出し、空（から）の状態にしてください。全てのポケットをご確認ください。\n・型崩れしないよう箱、段ボールなどに入れお送りください。\n\n※送付時・輸送中の破損については当社では責任を負いかねます。ご自身で適切に梱包してお送りください。。`}
                />

                <Accordion
                  title="スーツケース"
                  text={`・中身は必ず取り出し、何も入っていない状態（中身を空（から））にしてください。\n・「カギをあけて」送付してください。\n\n※送付時・輸送中の破損については当社では責任を負いかねます。ご自身で適切に梱包してお送りください。。`}
                />

                <Accordion
                  title="かさ・折りたたみ傘"
                  text={`・傘はよく乾かしてから梱包してください。（カビ発生の原因になります）\n・長傘は段ボール紙などに巻いて梱包し、輸送中に破損しないように工夫ください。\n・折りたたみ傘の袋は入れないでください。\n\n※送付時・輸送中の破損については当社では責任を負いかねます。ご自身で適切に梱包してお送りください。。`}
                />
              </div>
            </section>
            <section  id="item2-3" className={styles.item2Section}>
              <h3 className={styles.item2HeadingLv3}>「仮注文ID番号」を書いた紙を同封してください</h3>
              <div className={styles.textWrapper}>
                <p className={styles.text}>配送修理の受付完了メールに記載の「仮注文<span className={styles.isBold}>ID</span> 番号（数字<span className={styles.isBold}>6</span>桁）」を、メモ用紙などの紙に書き、修理品に同封してください。<br />リペアセンターで照合するために利用いたします。</p>
                <p className={styles.cautionText}>2つ以上同時注文される場合は、必ずそれぞれのIDを入れてください。 同一カテゴリの場合（例：靴と靴の場合）、どちらがどちらのIDかわかるようにしてください。<br />(例：それぞれの修理品の中に用紙を入れる、など)</p>
                <p className={styles.cautionText}>仮注文IDがない場合、問い合わせ内容と修理品の照合に時間がかかります。必ず、番号をお間違えなくご記入ください。</p>
                <p className={`${styles.cautionText} ${styles.block}`}>仮注文ID番号は、「配送修理の受付完了メール」か、ユーザー登録完了後に「<a href='/account'>マイページ</a>」でご確認いただけます。</p>
              </div>
              <div className={styles.idContentWrapper}>
                <div className={styles.idFlex}>
                  <figure className={styles.idImgWrapper}>
                    <picture>
                      {/* <source media="(min-width: 768px)" srcSet={Img08} /> */}
                      <img src={Img_repair} alt="Img08" width={1120} height={1750} />
                    </picture>
                  </figure>
                  <div className={styles.idAlert}>
                    <p className={styles.idAlertText}>・仮注文ID番号 の書かれた紙（メモ）を入れてください</p>
                    <p className={styles.idAlertText}>・スーツケースはカギをかけないでください。</p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div id="item3" className={styles.item3}>
          <h2 className={styles.headingLv2}>修理品をリペアセンターに発送する（発払い）</h2>
          <p className={styles.cautionText}><span className={styles.isBold}>発送時は必ず「発払い」でお送りください。（送料はお客様ご負担です）</span></p>
          {/* <a href="" className={styles.textLink}>配送費用・送料について詳しくはこちら</a> */}
          <div id="item3-1" className={styles.item3_1}>
            <h3 className={styles.headingLv3}>発送方法</h3>
            <p className={styles.text}>リペアセンターへの発送は、どの宅配サービスでもご利用いただけます。</p>
            <ul className={styles.ulList}>
              <li className={styles.ulItem}>集荷を自宅に依頼</li>
              <li className={styles.ulItem}>コンビニエンスストア、配送拠点に持ち込む</li>
            </ul>
            <p className={styles.text}>などの方法があります。<br />ご依頼になる配送業者のホームページなどで詳細はご確認ください。配送業者により会員になると特典が受けられる場合があります。</p>
            <br />
            <p className={styles.text}>例：ヤマト運輸<br /><a href="https://www.kuronekoyamato.co.jp/ytc/customer/send/">https://www.kuronekoyamato.co.jp/ytc/customer/send/</a></p>
            <p className={styles.cautionText}>リペアセンターにお客様による直接のお持ち込みはお断りしております。必ず宅配便をご利用ください。</p>
          </div>
          <div id="item3-2" className={styles.item3_1}>
            <h3 className={styles.headingLv3}>伝票の書き方</h3>
            <p className={styles.text}>伝票には、ユーザー登録と同じの</p>
            <ul className={styles.ulList}>
              <li className={styles.ulItem}>お名前</li>
              <li className={styles.ulItem}>電話番号</li>
              <li className={styles.ulItem}>住所</li>
            </ul>
            <p className={styles.text}>を伝票に記載してください。リペアセンターでの照合に活用いたします。<br />送付先の住所は<a href='/account'>マイページ</a>でご確認ください。</p>
            <div className={styles.whiteBox}>
              <p className={styles.whiteText}>・発送時は必ず「発払い」でお送りください。（送料はお客様ご負担です）</p>
              <p className={styles.whiteText}>・お支払い（決済）は、リペアセンターで修理依頼品を確認し、検品を行った後にご依頼いたします。</p>
            </div>
            <div className={styles.cautionTextWrapper}>
              <p className={styles.cautionText}>東京都への発送となります</p>
            </div>
          </div>
        </div>
        <div id="item4" className={styles.item4}>
          <h2 className={styles.headingLv2}>修理完了品を受け取る</h2>
          <div className={styles.item4Content}> 
            <p className={styles.text}>修理が完了次第、リペアセンターから 事前に登録いただきました住所あてに アイテムを発送いたします。<br />発送時メールにてお知らせいたしますので ご確認、受け取りをお願いいたします。</p>
            <div className={styles.headingLv3Wrapper}>
              <h3 className={styles.headingLv3}>返送の送料（返送料）について</h3>
            </div>
            <div className={global.tableFlex}>
              <div>
                <h4 className={global.headingLv4}>靴・スニーカー・バッグ・かさなど（スーツケース以外）</h4>
                
                <div className={global.tableContainer}>
                  <table className={global.shippingTable}>
                    <tbody>
                      <tr>
                        <th>3,300円(税込)以上</th>
                        <td>無料</td>
                      </tr>
                      <tr>
                        <th>3,300円(税込)未満</th>
                        <td>880円(税込)</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p className={global.tableCautionText}>沖縄県への場合は、梱包サイズに応じた返送料をご請求いたします。（ヤマト運輸宅急便の料金表に準じます)</p>
                <a href='https://www.kuronekoyamato.co.jp/ytc/search/estimate/okinawa.html' target="_blank" className={global.tableLinkText}>https://www.kuronekoyamato.co.jp/ytc/search/estimate/okinawa.html</a>
              </div>
              <div>
                <h4 className={global.headingLv4}>スーツケース</h4>
                <div className={global.tableContainer}>
                <table className={global.shippingTable}>
                  <tbody>
                    <tr>
                      <th>一律</th>
                      <td>1,650円（税込）</td>
                    </tr>
                  </tbody>
                </table>
                </div>
                <p className={global.tableCautionText}>沖縄県への場合は、梱包サイズに応じた返送料をご請求いたします。（ヤマト運輸宅急便の料金表に準じます)</p>
                <a href='https://www.kuronekoyamato.co.jp/ytc/search/estimate/okinawa.html' target="_blank" className={global.tableLinkText}>https://www.kuronekoyamato.co.jp/ytc/search/estimate/okinawa.html</a>
              </div>
            </div>
          </div>
        </div>
        <div id="item5" className={styles.item5}>
          <h2 className={`${styles.headingLv2} ${styles.isCenter}`}>よくある質問</h2>
          <div className={styles.accordionWrapper}>
            <Accordion
              title="配送修理で返送される時、どの運送会社で届きますか？到着日の指定はできますか？"
              text={`ミスターミニット リペアセンターからは、ヤマト運輸の宅急便で返送いたします。\n到着日の指定はできません。お客様で変更をお願いいたします。`}
            />
          </div>
          <div className={styles.accordionLinkWrapper}>
            <a className={styles.accordionLink} href="https://www.minit.co.jp/support/faq/mitsumori-ec/" target="_blank">すべての質問はこちら</a>
          </div>
        </div>
      </div>
    </div>
  );
};
